import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { WebcamImage } from 'ngx-webcam';
import { Observable, of } from 'rxjs';
import { debounceTime, map, startWith, switchMap, tap } from 'rxjs/operators';
import { PeopleDto } from '../models/people.model';
import { SurveyQuestion } from '../models/survey-question.model';
import { CameraService } from '../services/camera.service';
import { ImageService } from '../services/image/image.service';
import { SurveyService } from '../services/survey.service';


export interface ExternalTestData {
  surveyEntryId: number;
  nameOnTest: string;
  dateOfBirth: Date;
  testResult: string;
  testMethod: string;
  testDate: Date;
  files: any[];
}


//export const MY_FORMATS = {
//  parse: {
//    dateInput: 'MM/YYYY',
//  },
//  display: {
//    dateInput: 'MM/YYYY',
//    monthYearLabel: 'MMM YYYY',
//    dateA11yLabel: 'LL',
//    monthYearA11yLabel: 'MMMM YYYY',
//  },
//};

@Component({
  selector: 'app-external-test-upload',
  templateUrl: './external-test-upload.component.html',
  styleUrls: ['./external-test-upload.component.css']
  //providers: [
  //    {
  //      provide: DateAdapter,
  //      useClass: MomentDateAdapter,
  //      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  //    },

  //    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  //],
})
export class ExternalTestUploadComponent implements OnInit {
  files = [];
  data: ExternalTestData;

  uploadUrl: string;
  currentQuestion: SurveyQuestion;
  color: string = "black";
  weight: string = "normal";

  @ViewChild('covidForm', { static: false }) covidForm;
  @ViewChild('camera', { static: false }) camera;
  @Output() externalUploadEvent = new EventEmitter<ExternalTestData>();
  myPeoplePickerFormGroup: UntypedFormGroup;
  @Input() surveyUrl: string;
  @Input() surveyEntryId: number;

  dobInput = new UntypedFormControl("");
  testDateInput = new UntypedFormControl("");

  maxDate = new Date();
  minDate1900 = new Date(1900, 1, 1);
  minDate2020 = new Date(2020, 1, 1);
  groups = [];
  markets = [];
  selectedGroup: any;

  constructor(private cameraService: CameraService,
    private imageService: ImageService,
  ) { }

  async ngOnInit() {
    this.data = {} as ExternalTestData;
  }

  ngDoCheck() {
    
    //if (this.covidForm.status == "INVALID") return;
    if (this.data.nameOnTest === undefined || this.data.nameOnTest === '') return;
    if (this.data.dateOfBirth === undefined) return;
    if (this.files.length == 0) return;
    if (this.data.testResult === undefined) return;
    if (this.data.testMethod === undefined) return;
    if (this.data.testDate === undefined) return;
    if (this.dobInput.invalid) return;
    if (this.testDateInput.invalid) return;

    // this.data.files = this.files;
    // console.log('docheck files',this.data.files);

    if (this.surveyUrl !== '/survey/covidexposuretestupload') {
      console.log('do check', this.data);
      this.data.files = this.files;
      this.externalUploadEvent.emit({ ...this.data });
    }
    
  }

  handleImage(pictures) {
    console.log('CovidTestComponent.handleImage', pictures);
    this.files = [];
    pictures.forEach(p => {
      this.imageService.resizeImage(p.imageAsDataUrl, 1000, 1000).then(data => {
        this.files.push(data);
      });
    });
  }

  onSelectFile(event) { // called each time file input changes
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url      
      reader.onload = (event) => { // called once readAsDataURL is completed
        if (reader.result.toString().includes("image") || reader.result.toString().includes("application/pdf")) {
          this.uploadUrl = reader.result.toString();
          this.color = "black";
          this.weight = "normal";
          // only resize images
          if (reader.result.toString().includes("image")) {
            this.imageService.resizeImage(reader.result.toString(), 1000, 1000).then(data => {
              this.files.push(data);
            });
          }
          else{
            this.files.push(reader.result);
          }
        }
        else {
          this.color = "red";
          this.weight = "bold";
          this.uploadUrl = "";
        }
      }
    }
  }

  getDOBInputErrorMessage() {
    return this.dobInput.hasError("required") ? "You must enter a value" : this.dobInput.hasError("matDatepickerMin")
      ? "Invalid minimum date" : this.dobInput.hasError("matDatepickerMax")
        ? "Invalid maximum date" : this.dobInput.hasError("matDatepickerParse")
          ? "Invalid date" : "";
  }

  getTestDateInputErrorMessage() {
    return this.testDateInput.hasError("required") ? "You must enter a value" : this.testDateInput.hasError("matDatepickerMin")
      ? "Invalid minimum date" : this.testDateInput.hasError("matDatepickerMax")
        ? "Invalid maximum date" : this.testDateInput.hasError("matDatepickerParse")
          ? "Invalid date" : "";
  }

  submit(){
    this.data.files = this.files;
    this.data.surveyEntryId = this.surveyEntryId;
    this.cameraService.saveExternalCovidTestData(this.data).subscribe((res) => {
      this.externalUploadEvent.emit({ ...this.data });
    })
  }
}
